import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Layout } from '../components/layout/Layout';
import { motion } from 'framer-motion';

export const StaticPage = ({ pageSlug }) => {
  const { t, getLocalizedText, API } = useApp();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await fetch(`${API}/pages/${pageSlug}`);
        if (res.ok) {
          const data = await res.json();
          setPage(data);
        }
      } catch (err) {
        console.error('Failed to fetch page', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [pageSlug, API]);

  if (loading) {
    return (
      <Layout>
        <div className="max-w-3xl mx-auto px-4 py-8">
          <div className="animate-pulse">
            <div className="h-10 bg-gray-200 rounded mb-8" />
            <div className="space-y-4">
              <div className="h-4 bg-gray-200 rounded" />
              <div className="h-4 bg-gray-200 rounded" />
              <div className="h-4 bg-gray-200 rounded w-3/4" />
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  if (!page) {
    return (
      <Layout>
        <div className="max-w-3xl mx-auto px-4 py-16 text-center">
          <h1 className="font-heading text-3xl font-bold mb-4">Page Not Found</h1>
          <Link to="/" className="text-primary hover:underline">
            Return Home
          </Link>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 py-8" data-testid={`page-${pageSlug}`}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-[#1A1625] mb-8 text-center">
            {getLocalizedText(page.title)}
          </h1>

          <div
            className="prose prose-lg max-w-none text-foreground prose-headings:font-heading prose-headings:text-[#1A1625] prose-a:text-primary"
            dangerouslySetInnerHTML={{ __html: getLocalizedText(page.content) }}
          />
        </motion.div>
      </div>
    </Layout>
  );
};

export const AboutPage = () => <StaticPage pageSlug="about" />;
export const PrivacyPage = () => <StaticPage pageSlug="privacy" />;
export const TermsPage = () => <StaticPage pageSlug="terms" />;

export default StaticPage;
